// ESM-Huelle um lib/scripts/pos/CLS_CPOS.js (Phase 4, Welle 4c).
// Prototype-Stil bleibt vorerst.

// Strict-Mode-Fix (ESM): implizit zugewiesene Sloppy-Mode-Globals.
var sql;
"use strict";

function CPOS() {
    /*privMan.enablePrivilege (privList);*/
    var me = this;
    this.events = new CEventDispatcher();
    this.mover = new CMover();
    this.tools = new CTools();
    this.lang = new CLanguage("de");
    this.sessions = new CSessionHandler();
    this.cache = new CCache();
    this.timeout = new CTimeOut();
    this.rights = new CUserRights();
    this.sound = new CSound();
    // Load Ini Data:
    this.POSId = this.readIniFile("var/db/import/POSId");

    this.ATU = this.readIniFile("var/db/import/ATU");

    this.xml = new CXmlHandler("var/etc/ini.xml");
    this.ProgramVersion = this.xml.convert2Object("initData.programVersion");
    this.BKVersion = this.xml.convert2Object("initData.BKVersion");
    this.VATNormal = this.xml.convert2Object("initData.VAT.Normal");
    this.VATErm1 = this.xml.convert2Object("initData.VAT.Erm1");
    this.VATErm2 = this.xml.convert2Object("initData.VAT.Erm2");
    this.VATNull = this.xml.convert2Object("initData.VAT.Null");
    this.VATStandard = this.xml.convert2Object("initData.VAT.Standard");
    this.RKSuite = this.xml.convert2Object("initData.RKSuite");
    this.firstBONID = this.xml.convert2Object("initData.FirstBONRegID");
    this.UpdateServer = this.xml.convert2Object("initData.UpdateServer");
    this.UpdatePort = (this.xml.convert2Object("initData.UpdatePort")?this.xml.convert2Object("initData.UpdatePort"):8011);

    // ---
    this.isDisplayActive = 0;
    this.displayAdvertTo = null;
    this.DisplayStatusFile = "var/DisplayStatus";

    this.runningRequest = false;

    this.focusedComponent = null;
    this.isPOSBeingOpened = false;
    this.isPOSBeingClosed = false;
    this.isPOSOpened = false;
    this.blockedStatus = false;
    this.bankomatActive = false;
    this.helpActive = false; //true = deaktiviert

    // xml handlers that have to be loaded at the beginning:
    this.xmlForBonOverlay = new CXmlHandler("etc/layout/LYT_bonOverlay.xml");
    this.xmlForBonOverlayPagedPanel = new CXmlHandler("etc/layout/LYT_bonOverlayPagedPanel.xml");
    this.havePrinter = 1;

    this.displaywindow = null;
    this.httpDisplayServer = null;
    this.displayres = null;
    this.http = null;
    this.POSType = "Master";
    this.otherPOS = new Array();

    this.Smartcard = null;
    this.waitingForBunches = false;

    $.when(getMyIP(this)).done(function (result) {
        me.MyIP = result;
    });
    this.isOffline = false;

}

CPOS.prototype.start = function () {

    this.EnvProperties = this.getEnvProperties();

    this.overlay = new COverlay("template.overlay");
    this.overlay.draw();
    this.message = new CMessage("template.message");
    this.message.draw();
    this.hourGlass = new CHourGlass("template.hourGlass");
    this.hourGlass.draw();

    try {
        fs.accessSync('/home/pos/var/etc/isOffline');
        this.isOffline = true;
        this.timeout.register("OfflineTimeout", this.checkIfOffline, this, 1200); //1200 *0,25 = 300s = 5min
        //this.checkIfOffline(this);

    } catch (e) {}

    this.Cashbox = new CCashbox();
    this.wsclient = new CRunClient();
    this.wsclient.init();

    if (this.EnvProperties.BANKOMATTERMINALIP && this.EnvProperties.BANKOMATTERMINALIP.length > 7) {
        this.Bankomat = new CZVTBankomatHandler();
    } else {
        this.Bankomat = new CBankomat();
    }

    this.Bankomat.client = this.wsclient;
    //   this.Ping = new CPing();
    //    this.DataImport = new CDataImport();
    //   this.DataExport = new CDataExport();
    this.Screensaver = null;

    //POS.timeout.register("AliveTimeout", this.registerTimeout, this, 40);

    if (fs.existsSync("var/db/import/POSId") || fs.existsSync("var/db/import/POSId.bak")) {
        this.hourGlass.show(null, this, this.showLogin);
    } else {
        this.hourGlass.show(null, this, this.inputPOSID);
    }
    ////////testing
    //this.showLogin(this);
}

CPOS.prototype.inputPOSID = function (cls) {
    cls.hourGlass.hide();
    cls.EnvProperties.CUSTOMERDISPLAY = "NO";
    cls.EnvProperties.BANKOMATTERMINAL = "NO";
    cls.EnvProperties.PRINTER = "NO";
    cls.EnvProperties.CASHBOX = "NO";
    cls.sessions.openSessions[0] = new CPOSIDScreen("0");
    cls.sessions.openSessions[0].properties.styles.zIndex = "1";
    cls.sessions.openSessions[0].draw();
    cls.sessions.openSessions[0].components.container.components.posid.field.input.setFocus();
}

CPOS.prototype.PeriodicBunchQuery = function (cls) { //macht nur Slave
    //  var ts = 0;
    var me = this;
    if (!(me.waitingForBunches)) {
        me.waitingForBunches = true;
        var ts = (Date.now() / 1000 | 0) - 1209600; //14*24*60*60; //14 Tage zurück
        var sql = "SELECT MIN(BONE.Foreign_ID) as ID from BONE where TS>" + ts + " and BONE.Foreign_ID>'999999999'";
        var r = POS.SQLiteCon.execute(sql);
        $.when(r).then(function (rows) {
            //var sql1 = "SELECT PROD_ID FROM PROD WHERE PROD_ID>=1000009923 ORDER BY PROD_ID ASC";
            var sql1 = "SELECT PROD_ID FROM PROD WHERE PROD_ID>=" + rows[0].ID + " ORDER BY PROD_ID ASC";
            var r1 = POS.SQLiteCon.execute(sql1);
            $.when(r1).then(function (rows) {
                var missingIDS = [];
                var id = 0;
                if (rows && rows.length > 0) {
                    id = rows[0].PROD_ID;
                    var previd = rows[0].PROD_ID;
                    for (var i = 0; i < rows.length; i++) {
                        id = rows[i].PROD_ID;
                        var tmpid = id;
                        while (tmpid - previd > 1) {
                            missingIDS.push(tmpid - 1);
                            tmpid = tmpid - 1;
                        }
                        previd = id;
                        //  j = j + 1;
                    }
                }
                missingIDS.push(id + 1);
                //me.waitingForBunches = true;
                //
                var data = {
                    "host": cls.Master,
                    "port": 9000,
                    "data": "requestbunch " + JSON.stringify({
                        "prodids": missingIDS,
                        "ip": cls.myipaddress
                    })
                }
                var url = "request.php";
                $.when(new CRunClient().sendDataAsync(null, null, null, null, 0, null, url, data)).then(function (data, error) {
                    if (data) {
                        me.waitingForBunches = false;
                    } else if (error) {
                        log.add(4, "Fail", "Bunches could not be requested!", status);
                        me.waitingForBunches = false;
                    }
                });
            });
        })
    }
    /*var waitfor = Integer(cls.POSId*3000);
    setTimeout(function() {
    //  cls.PeriodicBunchQuery(cls);
    }, waitfor);*/
}

CPOS.prototype.showLogin = function (cls) {

    cls.connectDb();
    ///testing
    /* function hexToBytes(hex) {
    let bytes = [];
    for (let c = 0; c < hex.length; c += 2)
    bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
    }*/
   // var data1= Buffer.from(String('040f09270004000000000020'), 'hex');
/*
    var data1= Buffer.from(String('0202020f27000400000003952560f0f5f367216742000000000000000000000000000016000000039525000000000000000000000000000000000000000000000000000000000b0597410c1900270d03060f00'), 'hex');
    //var data1= Buffer.from(String('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'), 'hex');
    //var data1 = hexToBytes(String('040f4f2700040000000392560f0f5f367216742000000000000000000000000000016000000039525000000000000000000000000000000000000000000000000000000000b0597410c1900270d03210600'));
    //POS.Bankomat.parseparseTLVInfo(data1);
	POS.Bankomat.endOfDayReply(data1);
    POS.Bankomat.transactionstatus=[];
    POS.Bankomat.parseStatusInfo(data1);
    POS.Bankomat.cardBalanceFinish();*/
    //end testing

    var sql = "SELECT shops2.POS_ID as ids,shops2.Type as Type,shops1.SHOP_ID as shopid,shops2.IPAddress as address from SHOPS as shops1 join SHOPS as shops2 on shops2.SHOP_ID=shops1.SHOP_ID where shops1.POS_ID =" + cls.POSId; ;
    //var sql = "SELECT Type,SHOP_ID,POS_ID,IPAddress FROM SHOPS where POS_ID ="+cls.POSId;
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        if (rows.length > 1) {
            for (var i = 0; i < rows.length; i++) {
                if (rows[i].ids == cls.POSId) {
                    if (rows[i].Type && rows[i].Type.length > 0) {
                        cls.POSType = rows[i].Type;
                        cls.myipaddress = rows[i].address;
                    }
                }
                if (rows[i].Type && rows[i].Type == "Master") {
                    cls.Master = rows[i].address;
                    cls.MasterID = rows[i].shopid;
                }

            }

            cls.otherPOS = rows;

            if (cls.POSType !== 'Master') {
                //cls.Master='127.0.0.1';
                //cls.PeriodicBunchQuery(cls);
                var waitfor = parseInt(cls.POSId) * 3000;
                setTimeout(function () {
                    cls.PeriodicBunchQuery(cls);
                }, waitfor);
            }

        } else {
            cls.MasterID = cls.POSId;
        }

        //--tesr
        //	cls.Master="192.168.100.138";
        //    cls.myipaddress="192.168.100.138";

        //   cls.PeriodicBunchQuery(cls);
        //end test

        /*
        if (cls.otherPOS.length > 1) {
        //var sql3 = require('sqlite3');
        var err = false;
        var reportsdb = new CSQlite(fs.getMyDir()+"var/db/POSysseus_Reports.db"); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);
        var sql = "SELECT sql FROM sqlite_master WHERE type='table' AND name='PRODSELLINGS'";
        $.when(reportsdb.execute(sql)).then(function(rows){
        //reportsdb.execute(sql, function(err, rows) { // create slave tables
        var iterator = function(i) {
        if (i < cls.otherPOS.length) {
        if (cls.otherPOS[i].Type && !err) {
        var name = "";
        if (cls.otherPOS[i].Type == "Slave") {
        var ips = cls.otherPOS[i].address.split(".");
        name = "slave" + ips[3];
        } else {
        name = "master";
        }
        var sql = rows[0].sql;
        sql = sql.replace("PRODSELLINGS", " IF NOT EXISTS PRODSELLINGS" + name);
        reportsdb.run(sql, function(err, rows) {
        iterator(i + 1);
        });
        }
        } else {
        //reportsdb.close();
        return;
        }
        }
        iterator(0);
        });
        }
         */
        //cls.httpServer(); //start http server

        cls.sessions.openSessions[0] = new CLoginScreen("0", "Login");
        cls.sessions.openSessions[0].properties.styles.zIndex = "1";
        cls.sessions.openSessions[0].draw();

        cls.Screensaver = POS.sessions.openSessions[0].addChild(CScreenSaver);

        cls.sessions.openSessions[0].components.container.components.user.field.input.setFocus();

        cls.hourGlass.hide();
        /////
        debugger;
        var sc = new CSmartcard();
        cls.Smartcard = sc;
        // Kassenstart = Kassenserver liest Konfig + SEE-Historie neu und prueft
        // einen anstehenden Wechsel vor (tools/RKSV-ONLINE-SIGNATUR.md 5).
        // Start-Meldung: Karte wie bisher (init zeigt die Ausfall-Meldung, hier
        // folgt der Starttext - Ruling 23); A-Trust GENAU eine Meldung mit dem
        // A-Trust-Text (Ruling 19).
        $.when(sc.init(true)).then(function (result) {
            if (!result) {
                POS.message.show(sc.startMeldung(), "warning", "OK");
            }
            var Receipt = new CReceipt(-1); //Werte initialisieren = laden
            // RKSV Nacharbeit B: gesperrte Kasse - Schlussbeleg in BONREG sichern.
            if (sc.ausserBetrieb) sc.schlussbelegBeimStart();
        });

        $.when(cls.getInfoPOSOpened()).then(function () {
            if (!cls.isPOSOpened) {
                POS.Cashbox.canBeOpen = true;
                POS.Cashbox.countdown = -1;
            }

            if (POS.EnvProperties.SCREENSAVER == "YES") {
                var seconds = cls.EnvProperties.SCREENSAVERTIME;
                POS.timeout.register("POS.testInactivity()", POS.testInactivity, null,
                    seconds * 1000 / 250);
            }

            if (typeof UIDParam != "undefined")
                cls.sessions.addSession(UIDParam);

            //cls.DataImport.firstStage(cls.DataImport);
            if (cls.EnvProperties.STARTDELAY && cls.EnvProperties.STARTDELAY > 0) {
                setTimeout(cls.hourGlass.hide, cls.EnvProperties.STARTDELAY * 1000);
                cls.hourGlass.show(cls.lang.getText("MESSAGES", "PLEASE_WAIT"));
            }
        });
    });

}

CPOS.prototype.testInactivity = function () {
    var d = new Date();
    var newTS = parseInt((d / 1000).toFixed(0));

    var timeLimit = parseInt(POS.EnvProperties.SCREENSAVERTIME) - 5;

    if (newTS - parseInt(POS.events.lastTS) > timeLimit && POS.events.applyTS) {
        if (POS.hourGlass.isActive() || POS.helpActive)
            return;
        POS.message.holdMessage = true;
        POS.message.hide();
        POS.sessions.hideCurrentSession();
        POS.Screensaver = POS.sessions.openSessions[0].addChild(CScreenSaver);
        POS.Screensaver.draw();
        POS.events.applyTS = false;
    }

}

CPOS.prototype.connectDb = function () {
    /*privMan.enablePrivilege (privList);*/

    /*  var VisoTech = Components.classes["@visotech.at/VisoTech;1"].
    createInstance(Components.interfaces.nsIVisoTech);*/
    //  var fileHandler = new CFileHandler();
    var myDir = fs.getMyCleanDir();

    this.prepareDb();

    this.SQLiteCon = new CSQlite(myDir + "/var/db/POS.db");
    // this.SQLiteCon = VisoTech.sqliteConnect(myDir + "/var/db/POS.db");
    /*
    var debuggerService = Components.classes["@mozilla.org/js/jsd/debugger-service;1"].
    getService(Components.interfaces.jsdIDebuggerService);
     */
    //this.prepareDbTables();
}

CPOS.prototype.prepareDb = function () {
    /*var POSDb = new CFileHandler();
    POSDb.fileName = "var/db/POS.db";

    if (!POSDb.open(false)) {
    var CleanPOSDb = new CFileHandler();
    CleanPOSDb.fileName = "var/db/POSBlumen.db";
    CleanPOSDb.open(false);
    CleanPOSDb.file.copyTo(null, "POS.db");

    return true;
    } else
    return false;
     */
    return true;
}

CPOS.prototype.prepareDbTables = function () {
    /*privMan.enablePrivilege (privList);*/

    var ZIPsTable = "CREATE TABLE ZIPS (BON_ID INTEGER NOT NULL PRIMARY KEY UNIQUE, ZIP string, Exported bool DEFAULT '0');"

        var sql = "SELECT name FROM SQLite_Master where name = 'ZIPS'";
    $.when(this.SQLiteCon.execute(sql)).then(function (rows) {
        if (rows.length < 1) {
            POS.SQLiteCon.execute(ZIPsTable);
        }

    });
    /* if (!r.recordCount())
    this.SQLiteCon.execute(ZIPsTable);

    r.free();*/
}

CPOS.prototype.getComponentById = function (id) {
    var component = null;

    if (typeof id == "undefined")
        return null;

    //return document.getElementById(id);
    if (typeof id == "number")
        id = String(id);

    if (typeof id == "string")
        id = id.toString().split(":");

    switch (id[0]) {
    case "template.hourGlass":
        component = this.hourGlass;
        break;
    case "template.message":
        component = this.message;
        break;
    default:
        //id = id[0];
        component = this.sessions.openSessions[id[0]];
    }

    for (var i = 1; i < id.length; i++)
        component = component.children[id[i]];

    return component;
}

CPOS.prototype.gotFocus = function (id) {
    this.focusedComponent = this.getComponentById(id);
}

CPOS.prototype.lostFocus = function (id) {
    if (this.focusedComponent && this.focusedComponent.id == id)
        this.focusedComponent = null;
}

CPOS.prototype.getCurrentSession = function () {
    return this.currentSession();
}

CPOS.prototype.getInfoPOSOpened = function () {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Start FROM BON WHERE Type = 'POP' AND Cancelled = 0 ORDER BY BON_ID DESC LIMIT 1";
    $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        if (rows.length < 1) {
            //r.free();
            return;
        }

        var timestampLastPOP = parseFloat(rows[0].Start);
        // var timestampLastPOP = parseFloat(r.getColumnByName("Start"));
        //r.free();

        sql = "SELECT Start FROM BON WHERE Type = 'PCR' AND Cancelled = 0 ORDER BY BON_ID DESC LIMIT 1";

        $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
            if (rows.length < 1) {
                // r.free();
                dfd.resolve();
                POS.isPOSOpened = true;
                return;
            }
            var timestampLastPCR = parseFloat(rows[0].Start);

            //var timestampLastPCR = parseFloat(r.getColumnByName("Start"));
            // r.free();

            if (timestampLastPOP > timestampLastPCR) {
                dfd.resolve();
                POS.isPOSOpened = true;
            } else {
                dfd.resolve();
            }
        });
    });
    return dfd.promise();
}

CPOS.prototype.getEnvProperties = function () {
    //    var IniFile = new CFileHandler();
    var fileName = "var/etc/ini.txt";
    //IniFile.open();
    //IniFile.readOpen();
    var data = fs.readFileSync(fileName).replace(/\r/g, "");

    var dataLines = data.split("\n");
    var parameters = new Array();

    for (var i = 0; i < dataLines.length; i++) {
        if (dataLines[i] != "") {
            var dataParts = dataLines[i].split(" ");
            var key = dataParts[0].toUpperCase();
            if (dataParts[1]) {
                var value = dataParts[1].replace(/__/g, " ");
            } else {
                value = 0;
            }
            parameters[key] = value; //.toUpperCase();
        }
    }

    return parameters;
}

CPOS.prototype.readIniFile = function (fileName) {
    var data = fs.readFileSync(fileName).replace(/\r/g, "");
    var dataParts = data.split("\n");
    return dataParts[0];
}

CPOS.prototype.runPOSPush = function () {

    var me = this;
    if (!this.UpdateServer) {
        this.UpdateServer = getValueFromINIXML("UpdateServer");
    }
    execute("/home/pos/etc/scripts/run-pos-push " + me.EnvProperties.ORDERINGSSERVER + " " + me.UpdateServer + " " + POS.POSId + ";", 500);

    //$.when(getMyIP(me)).done(function (ip) { //$.get
    //execute("rsync -ae 'ssh -i /home/pos/.ssh/id_dsa'   /home/pos/var/db/POS.db  pos@" + me.UpdateServer + ":/huge/posdata/POS_" + POS.POSId + "/POSysseus/var/db/ ;");
    //});
}

CPOS.prototype.checkIfOffline = function (me) {
    if (me.isOffline == false)
        return;
    try {
        fs.accessSync('/home/pos/var/etc/isOffline');
        me.isOffline = true;

        var offline = function (me, result) {
            if (result && result != "YES")
                return;
            var ws = new CWebservice();
            var cb = function (success) {
                if (success) {
                    // fs ist CFileHandler (HTTP), kennt nur unlinkSync - "unlink"
                    // warf nach JEDER erfolgreichen Wiederinbetriebnahme, die Datei
                    // blieb liegen und die Meldung kam endlos wieder. Und "=="
                    // war ein Vergleich statt der Zuweisung (Code-Suche 30.9.2026).
                    fs.unlinkSync('/home/pos/var/etc/isOffline');
                    me.isOffline = false;
                    me.timeout.unregister("OfflineTimeout");
                } else {
                    var text = "Die Anmeldung ist fehlgeschlagen. Bitte Netzwerkverbindungen überprüfen! In ca. 5 Minuten erfolgt der nächste Versuch!";
                    me.message.show(text, "question", "OK", me);
                }
            }
            ws.startWebservice('wiederinbetriebnahme', cb, me.POSId);
        }
        var text = "Die Kasse ist nicht am Finanzamt registriert! Zur Registrierung OK drücken, ansonsten Abbrechen!";
        me.message.show(text, null, "YESNO", me, offline);
    } catch (e) {
        me.isOffline = false;
    }
}

CPOS.prototype.registerTimeout = function (me) {
    var d = new Date();

    var
    dateTimeToShow = expandInteger(d.getDate(), 2) + "." + (d.getMonth() + 1) +
        "." + (d.getYear() + 1900) + " - " + expandInteger(d.getHours(), 2) + ":" +
        expandInteger(d.getMinutes(), 2) + ":" + expandInteger(d.getSeconds(), 2);

    //var fh = new CFileHandler();
    fs.fileName = "var/log/timestamps.log";
    fs.overwrite(dateTimeToShow + "\n");
}

var consoleListener = {
    observe: function (aMessage) {
        const nsIScriptError = Components.interfaces.nsIScriptError;
        var scriptError = aMessage.QueryInterface(nsIScriptError);
        var label = "Console " +
            (scriptError.flags & nsIScriptError.warningFlag != 0 ? "warning" : "error");
        if (scriptError.lineNumber == 0)
            return;
        var toLog = scriptError.sourceName + ", line number: " + scriptError.lineNumber;
        log.add(4, label, aMessage.message, toLog);
    },
    QueryInterface: function (iid) {
        if (!iid.equals(Components.interfaces.nsIConsoleListener) &&
            !iid.equals(Components.interfaces.nsISupports)) {
            throw Components.results.NS_ERROR_NO_INTERFACE;
        }
        return this;
    }
};

/*
CPOS.prototype.CheckIfUpdated = function(result, what) {

var additionalLines = 5;
if (what == "node_modules")
additionalLines = 6;
if (result) {
var lines = result.split("\n");
var count = lines.length - additionalLines;
log.add(4, "Info", "Update " + what + " result: " + result, "");
if (count > 0)
reboot = true; //dann update
return true;
} else {
//defret.resolve(updated);
reboot = true; //wenn fehlgeschlagen auch reboot
return false;
}
}*/
/*
CPOS.prototype.CheckandUpdate = function() {

try {
var defret = jQuery.Deferred();
var reboot = false;
var me = this;

var CheckIfResolvedAfterTimeout = function(recheck) {
if (defret.state() == "pending")
defret.resolve(false)
};

//setTimeout(CheckIfResolvedAfterTimeout, 15000);

if (fs.existsSync("tmp/update")) {
fs.unlinkSync("tmp/update");
defret.resolve(reboot);
return defret.promise();
}

var CheckImportantFiles = function(recheck) {

var defret2 = jQuery.Deferred();
var POSIdFile = "var/db/import/POSId";
var ATUFile = "var/db/import/ATU";
var POSIdBAKFile = "var/db/import/POSId.bak";
var ATUBAKFile = "var/db/import/ATU.bak";
var dbFile = "var/db/POS.db";
var dbBAKFile = "var/db/POSbak.db";
var varsync = false;
var checkagain = false;
if (typeof me.POSId == "undefined" || me.POSId == null || me.POSId == 0 || me.POSId == "") {
if (recheck) {
varsync = true; //dann holen von zentral
} else {
checkagain = true;
if (fs.existsSync(POSIdBAKFile)) {
fs.writeFileSync(POSIdFile, fs.readFileSync(POSIdBAKFile)); //copy
log.add(4, "EInfo", "Restore POSID from POSIDbak", "");
reboot = true;
} else {
me.hourGlass.show(null, me, me.inputPOSID); //POSId manuell eingeben!!!!!
}
}
} else {
if (fs.existsSync(POSIdFile)) {
fs.writeFileSync(POSIdBAKFile, fs.readFileSync(POSIdFile)); //copy
log.add(4, "EInfo", "Save POSID", "");
}
}

if (typeof me.ATU == "undefined" || me.ATU == "" || me.ATU == null) {
if (recheck) {
varsync = true;
} else {
checkagain = true;
if (fs.existsSync(ATUBAKFile)) {
fs.writeFileSync(ATUFile, fs.readFileSync(ATUBAKFile)); //copy
reboot = true;
}
}
} else {
if (fs.existsSync(ATUFile)) {
fs.writeFileSync(ATUBAKFile, fs.readFileSync(ATUFile)); //copy
}
}

if ((fs.existsSync(dbFile) == true)) {
var stats = fs.statSync(dbFile);
var fileSizeInBytes = stats["size"];
var fileSizeInMegabytes = fileSizeInBytes / 1000000.0;
}

if ((fs.existsSync(dbFile) == false) || (fileSizeInMegabytes < 1)) {
if (recheck) {
varsync = true;
} else {
checkagain = true;
if (fs.existsSync(dbBAKFile)) {
fs.writeFileSync(dbFile, fs.readFileSync(dbBAKFile)); //copy
log.add(4, "EInfo", "Restore POS.dbfrom POSbak.db", "");
reboot = true;
}
}
} else {
fs.writeFileSync(dbBAKFile, fs.readFileSync(dbFile)); //copy
log.add(4, "EInfo", "Save POS.db", "");
}

if (varsync) {
if (me.UpdateServer) {

me.overlay = new COverlay("template.overlay");
me.overlay.draw();
me.message = new CMessage("template.message");
me.message.draw();
me.hourGlass = new CHourGlass("template.hourGlass");
me.hourGlass.draw();

me.hourGlass.show("Daten werden importiert. Bitte warten!", null, null);
$.when(execute("sudo /bin/bash /home/pos/etc/scripts/restore_config.sh " + me.UpdateServer + " " + me.POSId, 300000)).then(function(result) {
me.hourGlass.hide();
reboot = true;
defret2.resolve();
});
} else {
defret2.resolve();
}
} else if (checkagain) {
$.when(CheckImportantFiles(true)).done(function() {
defret2.resolve();
});
} else {
defret2.resolve();

}
return defret2.promise();
};

$.when(CheckImportantFiles()).done(function() {

defret.resolve(reboot);
//});
});
} catch (e) {
defret.resolve(false);
}
return defret.promise();
}

 */
CPOS.prototype.httpServer = function () {

    var enableCORS = function (req, res) {
        //   res.setHeader('Content-Type', 'text/html');
        res.setHeader('Access-Control-Allow-Origin', '*');
        res.setHeader('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,OPTIONS');
        //      res.setHeader('Access-Control-Allow-Headers', 'Content-Type, Authorization, Content-Length, X-Requested-With');
        res.setHeader('Access-Control-Allow-Headers', '*');
        /*
        // intercept OPTIONS method
        if ('OPTIONS' == req.method) {
        res.send(200);
        } else {
        next();
        }*/
    };

    //if ((POS.EnvProperties.CUSTOMERDISPLAY == "MONITOR") || (POS.otherPOS && POS.otherPOS.length>1)) {
    if (!POS.http) {

        $.fn.outerHTML = function () {
            return (this[0]) ? this[0].outerHTML : '';
        };

        // POS.http = require("http");
        var execto = null;

        var onRequest = function (req, res) {

            var postdata = false;
            var requesttype = 0; //display
            var refresh = false;
            //1 : sqlite
            //2: exceute

            //                enableCORS(req, res);

            if (req.url.indexOf('sqlite') >= 0) {
                postdata = true;
                requesttype = 1;
            } else if (req.url.indexOf('execute') >= 0) {
                postdata = true;
                requesttype = 2;
            } else if (req.url.indexOf('addbunch') >= 0) {
                postdata = true;
                requesttype = 3;
            } else if (req.url.indexOf('reports') >= 0) {
                postdata = true;
                requesttype = 4;
            } else if (req.url.indexOf('scanner') >= 0) {
                postdata = true;
                requesttype = 5;
            } else if (req.url.indexOf('video') >= 0) {
                postdata = true;
                requesttype = 6;
            } else if (req.url.indexOf('file') >= 0) {
                postdata = true;
                requesttype = 7;
            } else if (req.url.indexOf('requestbunch') >= 0) {
                postdata = true;
                requesttype = 8;
            }

            if (postdata) {
                var body = "";

                req.on('data', function (data) {
                    body += data;

                    // Too much POST data, kill the connection!
                    // 1e6 === 1 * Math.pow(10, 6) === 1 * 1000000 ~~~ 1MB
                    if (body.length > 1e6)
                        req.connection.destroy();
                });

                req.on('end', function () {

                    if (!body || body.length < 2) {
                        res.end("Error");
                        return;
                    }
                    switch (requesttype) {
                    case 1: //sqlite
                        break;
                    case 2: //execute
                        break;
                    case 3: //addBunch
                        var data = JSON.parse(body);
                        var userId = data["userid"];
                        var T = new CBonTransaction();
                        $.when(T.openBon(userId)).then(function (bonid) {
                            var currentBon = data["bon"];
                            var prod = data["prod"];
                            T.addBunchFromMaster(bonid, currentBon, prod.sum, prod.bunchtype, prod.qty, prod.barcode);
                            res.end("OK");
                        });
                        break;
                    case 4: //Slave Reports
                        break;
                    case 5: //Scanner
                        break;
                    case 6: //Video
                        var data = JSON.parse(body);
                        var videotime = data["video"];
                        //videotime = videotime.substring(0,8);
                        //  var filenamecomp = "stream_" + videotime.substring(0, 8);
                        var path = "/parspace/avi-server/";
                        fs.readdir(path, function (err, files) {
                            if (err) {
                                log.add(1, "Error", "in find Video: ", err);
                                res.end("error");
                                return;
                            }
                            if (files.length > 1) {
                                var filename = null;
                                var diff = 1000000;
                                for (var i = 0; i < files.length; i++) {
                                    var filesplit = files[i].split['_'];
                                    var time = filesplit[1];
                                    var newdiff = Math.abs(time - videotime);
                                    if (newdiff < diff) {
                                        diff = newdiff;
                                        filename = file[i];
                                    }
                                }
                            } else if (files.length > 0) {
                                filename = files[0];
                            } else {
                                res.end("no file");
                            }
                            filename = path + filename;
                            fs.readFile(filename, function (err, data) {
                                if (err) {
                                    log.add(1, "Error", "in find Video 2: ", err);
                                    res.end("error");
                                    return;
                                }
                                res.setHeader('Content-Type', 'application/octet-stream');
                                res.end(data);
                            });
                        });
                        break;
                    case 7: //File
                        var data = JSON.parse(body);
                        var filename = data["file"];
                        fs.readFile(filename, function (err, data) {
                            if (err) {
                                log.add(1, "Error", "in find Video 2: ", err);
                                res.end("error");
                                return;
                            }
                            res.setHeader('Content-Type', 'application/octet-stream');
                            res.end(data);
                        });
                        //res.end("OK");
                        break;
                    case 8: //requestbunch
                        if (!POS.runningRequest) {
                            POS.runningRequest = true;
                            var data = JSON.parse(body);
                            var prodids = data["prodids"];
                            var ip = data["ip"];
                            var T = new CBonTransaction();
                            $.when(T.getBFCsforSlave(prodids)).then(function (bfcs) {
                                res.end(JSON.stringify(bfcs));
                                POS.runningRequest = false;
                            });
                        } else {
                            res.end(JSON.stringify([]));
                        }
                        break;
                    }

                    // use POST
                });
            }

            try {

                //            POS.http.Server = POS.http.createServer(onRequest).listen(8888);
            } catch (ex) {
                //POS.displaywindow.close(true);
            }
        }
        //}
    }
}

export { CPOS };
